import React, {useEffect, useState, useRef, useCallback} from "react";
import styles from './CheckoutModal.module.scss';
import wrapStyles from "components/homePanels/l_customWraps/CustomWraps.module.scss";
import NavToggle from "components/icons/navToggle/NavToggle";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";

const CheckoutModal = (props) => {

    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch();
    const [checkoutUrl, setCheckoutUrl] = useState();
    const title = useRef();
    const initialized = useRef(false);
    const apiCalled = useRef(false);

    useEffect(()=>{

        if(!accessible.productModal && !initialized.current){

            initialized.current = true;

            if(title.current) title.current.focus()

            dispatch({ type: "SET_ACCESSIBLE",
                payload: {
                    ...accessible,
                    productModal: true
                }
            });
        }

    }, [accessible, dispatch, props.refocus])

    const closeModal = useCallback(()=>{

        props.toggleCheckoutModal(false)

        if(props.refocus) props.refocus.focus()

        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                productModal: false
            }
        });
    }, [accessible, dispatch, props]);

    useEffect(()=>{

        if(!apiCalled.current){

            apiCalled.current = true;

            let order = {
                "items": [
                    {
                        "id": props.sku,
                        "qt": 1
                    }
                ]
            };

            axios.post(`/api/cart`, order)
                .then((response)=>{
                    console.log(response)
                    if(!response.data.error){
                        setCheckoutUrl(response.data.redirect_url);
                    } else {
                        console.log('Error: ',response.data.error);
                        props.setError('Error: ',response.data.error);
                        closeModal()
                    }

                })
                .catch((error)=>{
                    console.log('Error: ',error.response);
                    props.setError('Error: There was a problem contacting our server. Please try again later');
                    closeModal()
                });

        }

    },[props, setCheckoutUrl, closeModal])



    function getButton(){
        if(checkoutUrl){
            return (
                <>
                    <a onClick={closeModal} className={styles.button} href={checkoutUrl} target={'_blank'} rel={'noreferrer'}>Check out*</a>
                    <div className={styles.disclaimer}>*Complete your purchase on <a href={checkoutUrl} target={'_blank'} rel={'noreferrer'}>dbrand.com</a></div>
                </>
            )
        } else {
            return <span>Checking...</span>
        }
    }

    return  (
        <div className={`${wrapStyles.modalWrapper} ${styles.checkoutModal}`}>
            <div className={`${wrapStyles.modalContent} ${styles.checkoutContent}`}>
                <div className={wrapStyles.close} onClick={closeModal}><NavToggle closeOnly={true}/></div>
                <h3 ref={title} tabIndex={-1}>Your cart is ready</h3>
                {getButton()}
            </div>
        </div>
    );

}

export default CheckoutModal;
